import { useField } from 'formik';

import { controlError } from 'utils/error';
import { UploadFile, UploadFileProps } from 'components/upload-file';

interface FileFieldProps extends Omit<UploadFileProps, 'error' | 'setFile'> {
  name: string;
}

export const FileField = ({ name, ...props }: FileFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const error = controlError(meta, name, 'File');

  return (
    <UploadFile
      error={error ?? null}
      src={typeof field.value === 'object' ? field.value?.src : field.value}
      setFile={async (file) => {
        await helpers.setValue(file);
        helpers.setTouched(true);
      }}
      {...props}
    />
  );
};
